export default {
      id: "notifications__geozone.entry-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__geozone.entry",
      toString: function () {
        return this.url;
      }
    }